import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import ProductItemCard from "../components/ProductItemCard";
import { Context } from "../context/MainContext";
import { productsFetchSuccess } from "../context/Action";
import { toast } from "react-toastify";
import {
  fetchProducts,
  fetchProductsBySearch,
  fetchProductsBycategory,
} from "../api/usersApi";
import ReactPaginate from "react-paginate";
import Loading from "../components/Loading";
import HeaderImg from "../components/HeaderImg";
import { productCategories } from "../assets/data/categories";

const Shop = () => {
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const { dispatch, products } = useContext(Context);

  const { name, cat } = useParams();
  const { pathname } = useLocation();

  const handlePageClick = (event) => {
    setPageNo(event.selected + 1);
  };

  const updateName = () => {
    if (cat) {
      const words = cat?.split("-");

      for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
      }

      const category = words.join(" ");

      return category;
    }
  };

  useEffect(() => {
    const handleMessageCount = async () => {
      setLoading(true);

      const category = updateName();

      try {
        const fetch = name
          ? fetchProductsBySearch(name, pageNo)
          : category
            ? fetchProductsBycategory(pageNo, category)
            : fetchProducts(pageNo);
        const res = await fetch;
        dispatch(productsFetchSuccess(res.data));
        setLoading(false);
      } catch (err) {
        setLoading(false);
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          err.toString();
        toast.error(message);
      }
    };

    handleMessageCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, name, cat, pageNo, pathname]);

  useEffect(() => {
    if (products) {
      setPageCount(products.totalPages);
    }
  }, [products]);

  useEffect(() => {
    setPageNo(1);
  }, [pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pageNo, cat]);

  return (
    <div>
      <HeaderImg title="Products" />

      <div className="shop">
        <div className="shop__left">
          <h2 className="shop__left__header">CATEGORIES</h2>

          <ul className="shop__left__cats">
            <li className="shop__left__cats__item">
              <Link to="/products">All Products</Link>
            </li>
            {productCategories.map((cat, i) => {
              return (
                <li key={i} className="shop__left__cats__item">
                  <Link to={cat.link}>{cat.name}</Link>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="shop__right">
          <h2 className="shop__left__header">
            {name ? name : cat ? updateName() : "SHOP"}
          </h2>

          <ul className="shop__left__catsAlt">
            <li
              className={
                "/products" === pathname
                  ? "shop__left__catsAlt__item alt"
                  : "shop__left__catsAlt__item"
              }
            >
              <Link to="/products">All Products</Link>
            </li>
            {productCategories.map((cat, i) => {
              return (
                <li
                  key={i}
                  className={
                    cat?.link === pathname
                      ? "shop__left__catsAlt__item alt"
                      : "shop__left__catsAlt__item"
                  }
                >
                  <Link to={cat.link}>{cat.name}</Link>
                </li>
              );
            })}
          </ul>

          {loading ? (
            <Loading />
          ) : products?.products?.length > 0 ? (
            <div className="shop__right__products">
              {products?.products?.map((product, i) => {
                return <ProductItemCard key={i} product={product} />;
              })}
            </div>
          ) : (
            <h6 style={{ textAlign: "center", fontSize: 20, opacity: 0.3 }}>
              No product found
            </h6>
          )}

          {pageCount > 1 && (
            <div style={{ marginTop: 40 }}>
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                pageCount={pageCount}
                breakLabel="..."
                //   renderOnZeroPageCount={null}
                onPageChange={handlePageClick}
                // pageRangeDisplayed={itemsPerPage}
                containerClassName={"paginationBttns"}
                previousLinkClassName={"previousBttn"}
                nextLinkClassName={"nextBttn"}
                disabledClassName={"paginationDisabled"}
                activeClassName={"paginationActive"}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Shop;
